import Head from "next/head"
import DefaultLayout from "@/components/DefaultLayout"
import MyAccountLayout from "@/components/MyAccountLayout"
import { useState, useEffect } from "react"
import styles from "@/styles/my-account/wishlist.module.scss"
import myAccountApi from '@/service/modules/myAccountApi'
import Image from 'next/image'
import { Button, message, Spin } from "antd"
import useCartActions from '@/utils/addTocartAction'
import WishlistEmpty from '@/svgs/Wishlist-empty.svg'
import { useCallbackState } from '@/utils/useRef'
import Link from 'next/link'
import CustomPagination from "@/components/CustomPagination"
import MyTags from "@/components/MyTags"

export default function MyaccountStatus() {
  const { addToCart } = useCartActions();
  const defaultPages = 1
  const defaultPageSize = 8
  const [wishType, setWishType] = useCallbackState('')
  const [totalList, setTotalList] = useState([])
  const [wishList, setWishList]: any[] = useState([])
  const [numArr, setNumArr] = useState([0, 0, 0, 0])
  const [pages, setPages] = useState(defaultPages)
  const [pageSize, setPageSize] = useState(defaultPageSize)
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(true)
  // const [btnLoading, setBtnLoading] = useState(Array(defaultPageSize).fill(false));
  const [btnLoading, setBtnLoading]: any = useState({});
  const getWishList = async () => {
    setLoading(true)
    try {
      let res = await myAccountApi.getWishList()
      if (res.data) {
        const { wishProducts } = res.data
        setTotalList(wishProducts)
        // dealData(wishProducts, "all_products")
        // dealNum(wishProducts)
      }
      setLoading(false)
    } catch (error) {
      console.error(error)
      setLoading(false)
    }
  }
  useEffect(() => {
    getWishList()
  }, [])

  useEffect(() => {
    dealData(totalList, wishType, pages, pageSize)
    dealNum(totalList)
  }, [totalList])

  const dealNum = (data: any[]) => {
    let freeShippingNum = 0, priceDropNum = 0, unavailableNum = 0
    data.forEach((v: any) => {
      if (v.freeShipping == 1 && v.inStock > 0) {
        freeShippingNum++
      }
      if (v.promotionTypeID == 2 && v.inStock > 0) {
        priceDropNum++
      }
      if (v.enabled == 0 || v.inStock < 1) {
        unavailableNum++
      }
    })
    setNumArr([data.length, freeShippingNum, priceDropNum, unavailableNum])
  }

  const dealData = (data: any[], type: string, pages?: number, pageSize?: number) => {
    let newData = []
    switch (type) {
      case "free_shipping":
        newData = data.filter((v: any) => { return v.freeShipping == 1 && v.inStock > 0 })
        break
      case "price_drop":
        newData = data.filter((v: any) => { return v.promotionTypeID == 2 && v.inStock > 0 })
        break
      case "unavailable":
        newData = data.filter((v: any) => { return v.enabled == 0 || v.inStock < 1 })
        break
      default:
        newData = data
    }

    const myPages = pages || defaultPages
    const myPageSize = pageSize || defaultPageSize
    const startIndex = myPageSize * (myPages - 1)
    const endIndex = myPages * myPageSize
    const newArr = newData.slice(startIndex, endIndex);
    setPages(myPages)
    setPageSize(myPageSize)
    setTotal(newData.length)
    setWishList(newArr)
  }

  const onRemove = async (id: any) => {
    setBtnLoading((prevLoading: any[]) => {
      const newLoading = { ...prevLoading };
      newLoading[id] = true;
      return newLoading;
    });
    try {
      let res = await myAccountApi.deleteWishItem(id)
      if (res.data) {
        setBtnLoading((prevLoading: any) => {
          const newLoading = { ...prevLoading };
          newLoading[id] = false;
          return newLoading;
        });
        setTotalList(newTotalList => newTotalList.filter((v: any) => v.wishProductID != id))
        message.success("Successful")
      }
    } catch (error) {
      console.error(error)
    }
  }

  const addToCartCallBack = (response: any) => {
    if (response != "error") {
      message.success("Successful")
    }
  }

  const onPageChange = (page: number, pageSize: number) => {
    dealData(totalList, wishType, page, pageSize)
  }

  const preOrderCallBack = async (pid: any) => {
    window.location.href = '/checkout?p=' + pid + '&t=1';
  }

  const navTabs = [{
    title: "All Products",
    name: "all_products"
  }, {
    title: "Free Shipping",
    name: "free_shipping"
  }, {
    title: "Price Drop",
    name: "price_drop"
  }, {
    title: "Unavailable",
    name: "unavailable"
  },]
  return (
    <>
      <Head>
        <title>
          Wishlist - My Account - BestDeals.co.nz
        </title>
      </Head>

      <DefaultLayout>
        <MyAccountLayout>
          <div className={styles['my-wishlist-status']}>

            <div className={styles['title']}>My Wishlist</div>

            <div className={styles['wishlist-tab']}>
              {
                navTabs.map((v: any, index: number) =>
                  <div
                    onClick={() => {
                      setWishType(v.name, (wishType: string) => {
                        dealData(totalList, wishType)
                      })
                    }}
                    className={`${styles['nav']} ${((v.name === "all_products" && !wishType) || wishType === v.name) && styles['active']}`}
                    key={index}
                  >{v.title}<span className={styles['num']}>{numArr[index] || 0}</span>
                  </div>
                )
              }
            </div>
            <Spin spinning={loading}>
              <div className={styles['wishlist-list']}>
                {
                  wishList.map((v: any) => {
                    const price = v.price && v.price.toFixed(2)
                    const priceArr = price.split('.')
                    const [a, b] = priceArr
                    return (
                      <div className={styles['goods-box']} key={v.wishProductID}>
                        <div className={styles['imgthumb']}>
                          <Link
                            href={v.url}
                            legacyBehavior
                          >
                            <a rel="noopener noreferrer">
                              <Image
                                alt='crazysales'
                                width={215}
                                height={215}
                                src={v.filename || "https://static.bestdeals.co.nz/images/2022v/img/logo.svg"}
                              />
                            </a>
                          </Link>

                        </div>
                        <div className={styles['info']}>
                          <Link
                            href={v.url}
                            legacyBehavior
                          >
                            <a className={styles['goodsName']} rel="noopener noreferrer">
                              {v.name}
                            </a>
                          </Link>

                          <div className={styles['specific']}>
                            <div className={styles['price']}>
                              <b>${a}<i>.{b}</i></b>
                            </div>
                            {
                              v.inStock > 0
                              &&
                              <MyTags
                                {...v}
                                isSingle={true}
                                newTag={<div className={`${styles['tag']} ${styles['tag-onSale']}`}>new</div>}
                                onSaleTag={<div className={`${styles['tag']} ${styles['tag-onSale']}`}>on sale</div>}
                                reducedTag={<div className={`${styles['tag']} ${styles['tag-reduced']}`}>reduced</div>}
                                freeShippingTag={<div className={`${styles['tag']} ${styles['tag-freeShipping']}`}>free shipping</div>}
                              />
                            }
                          </div>
                        </div>

                        <div className={styles['config']}>
                          {
                            // 库存
                            v.inStock > 0
                              ?
                              <>
                                {
                                  // 预售
                                  v.preSales == 1
                                    ?
                                    <Button href={`/checkout?p=${v.productID}&t=1`} className={`${styles['wishlist-btn']} ${styles['preOrderBtn']}`}>PRE-ORDER</Button>
                                    :
                                    <Button onClick={(event) => { addToCart(event, { productID: v.productID, qty: 1 }, addToCartCallBack) }} className={`${styles['wishlist-btn']} ${styles['addToCarBtn']}`}>Add to Cart</Button>
                                }
                              </>
                              :
                              <Button href={v.url} className={`${styles['wishlist-btn']} ${styles['addToCarBtn']}`}>Notify Me</Button>
                          }
                          <Button loading={btnLoading[v.wishProductID]} onClick={() => { onRemove(v.wishProductID) }} className={`${styles['wishlist-btn']} ${styles['removeBtn']}`}>Remove</Button>
                        </div>
                      </div>
                    )
                  }
                  )
                }

                {
                  !!(wishList.length === 0 && !loading)
                  &&
                  <>
                    <div className={styles['empty-box']}>
                      <div className={styles['icon-box']}>
                        <WishlistEmpty className={styles['empty-img']} />
                      </div>
                      <h3 className={styles['empty-title']}>{totalList.length > 0 ? "No items" : "Your Wishlist Is Empty !"}</h3>
                      <p className={styles['empty-desc']}>You can purchase any of the items from this wishlist by selecting the item and clicking the &apos;Add to Cart&apos; button.</p>
                    </div>
                  </>
                }

              </div>
            </Spin>
            <div style={{ 'textAlign': 'right' }}>
              <CustomPagination
                pages={pages}
                pageSize={pageSize}
                total={total}
                onChange={onPageChange}
                showQuickJumper={true}
                hideOnSinglePage={true}
                showSizeChanger={false}
              />
            </div>
          </div>
        </MyAccountLayout>
      </DefaultLayout>
    </>
  )
}